import { useSelector, useDispatch } from 'react-redux';
import { FiSettings } from 'react-icons/fi';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify'; // Assuming react-toastify is used for toasts
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import { cancelSub } from '../features/subscription/subscriptionSlice';
import { useSubStatus } from '../hooks/useSubStatus';
import PricingTable from './stripe/PricingTable';
import CancelSubscriptionModal from './userInfoComponents/CancelSubscriptionModal'; // Import the modal component

const SubscriptionDetails = () => {
    const dispatch = useDispatch();
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);

    // From eRedux
    const { subInfo, message } = useSelector(state => state.subscription);
    
    // Hook for subscription status
    const { hasSubscription } = useSubStatus();
    
    useEffect(() => {
        if (message) {
            toast(message); // Display the toast with the message
            dispatch({ type: 'subscription/clearMessage' }); // Dispatch an action to clear the message
        }
    }, [message, dispatch]);

    const handleCancelSubscription = () => {
        setShowCancelModal(true);
    };

    const confirmCancelSubscription = () => {
        dispatch(cancelSub());
        setShowCancelModal(false);
    };

    const closeModal = () => {
        setShowCancelModal(false);
    };

    // const handleModifySubscription = () => {
    //     console.log("Modify subscription clicked");
    // };

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    if (subInfo.subStatus === "canceled" || !hasSubscription) {
        return (
            <>  
                <div className='mb-4 text-left'>
                    <h2 className='text-xl font-semibold tracking-tight text-ink'>Reactivate your Subscription</h2>
                    <p className='text-sm text-ink-3'>Choose a plan to resume worker clock-in access.</p>
                </div>

                <div className='rounded-xl border border-border bg-surface-2 p-4'>
                    <PricingTable 
                        style={{ position: 'relative', width: '100%', maxWidth: '800px' }}/>
                </div>
                                

            </>
        );
    } else {
        return (
            <>
                <div className='mb-4 text-left'>
                    <h2 className='text-xl font-semibold tracking-tight text-ink'>Subscription Information</h2>
                    <p className='text-sm text-ink-3'>Current billing status and renewal timeline.</p>
                </div>
               
                <div className="w-full rounded-xl border border-border bg-surface-2 p-6">
                    <p className="mb-2 text-sm text-ink-2"><span className="font-semibold text-ink">Subscription Name:</span> {subInfo.subTier} </p>  
                    <p className="mb-2 text-sm text-ink-2"><span className="font-semibold text-ink">Status:</span> {subInfo.subStatus} </p>
                    
                    <p className="mb-2 text-sm text-ink-2"><span className="font-semibold text-ink">Period Start:</span> {new Date(subInfo.subPeriodStart * 1000).toLocaleDateString()}</p>
                    <p className="mb-2 text-sm text-ink-2"><span className="font-semibold text-ink">Period End:</span> {new Date(subInfo.subPeriodEnd * 1000).toLocaleDateString()}</p>
                    
                    {subInfo.cancel_at_period_end && (
                        <p className="mb-2 rounded-md bg-red-50 px-3 py-2 text-sm font-semibold text-red-600">
                            Subscription will cancel at period end
                        </p>
                    )}

                    {subInfo.subStatus === "trialing" && !subInfo.cancel_at_period_end && (
                        <p className="mt-4 rounded-md bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-700">
                            Please add a credit card before the trial cycle ends to avoid interruptions.
                        </p>
                    )}
                </div>

                <div className="relative flex justify-end mt-6">
                    <button
                        type="button"
                        className="inline-flex h-10 items-center rounded-md border border-border bg-surface px-3 text-label font-medium text-ink-2 transition hover:bg-surface-2"
                        onClick={toggleDropdown}
                    >
                        <FiSettings className="h-4 w-4" />
                    </button>
                    {dropdownVisible && (
                        <div className="absolute right-0 top-full z-10 mt-2 w-52 rounded-md border border-border bg-surface shadow-md">
                            {/* <button
                                type="button"
                                className="block w-full px-4 py-2 text-left bg-charcoal text-white hover:bg-teal"
                                onClick={handleModifySubscription}
                            >
                                Modify Subscription
                            </button> */}
                            <button
                                type="button"
                                className="block w-full rounded-md px-4 py-2 text-left text-label font-medium text-critical transition hover:bg-critical/10"
                                onClick={handleCancelSubscription}
                            >
                                Cancel Subscription
                            </button>
                        </div>
                    )}
                </div>

                {showCancelModal && (
                    <CancelSubscriptionModal
                        onClose={closeModal}
                        onConfirm={confirmCancelSubscription}
                    />
                )}

                <div className='mt-6 text-sm text-ink-2'>
                    <p>Contact us at <a className='underline text-ink' href="mailto:support@timestat.app">support@timestat.app</a> for any questions, concerns, or requests.</p>
                </div>
            </>
        );
    }
}

export default SubscriptionDetails;
